<script>
  import { LayerCake, Svg } from "layercake";
  import Column from "./Column.svelte";
  import { scaleBand } from "d3-scale";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  import { percentFormat } from "$utils/formats.js";
  import { AxisY } from "@urbaninstitute/dataviz-components";

  let { data } = $props();

  let categories = $derived([...new Set(data.map((d) => d.category))]);
  let labels = $derived([...new Set(data.map((d) => d.label))]);

  let xKey = "label";
  let yKey = "value";

  let seriesColors = [urbanColors.blue, urbanColors.black, urbanColors.yellow];
</script>

<div class="legend-row">
  {#each labels as label, i}
    <div class="legend-pair">
      <div class="box" style="background-color:{seriesColors[i]};"></div>
      <div class="name">{label}</div>
    </div>
  {/each}
</div>
<div class="all-charts">
  {#each categories as category, i}
    <div class="category-container">
      <div class="chart-container">
        <LayerCake
          padding={{ bottom: 7, top: 20 }}
          x={xKey}
          y={yKey}
          xScale={scaleBand().paddingInner(0.15)}
          yDomain={[0, 1]}
          data={data.filter((d) => d.category == category)}
          custom={{ xKey: xKey, seriesColors: seriesColors, format: percentFormat }}
        >
          <Svg>
            {#if i == 0}
              <AxisY formatTick={(d) => percentFormat.format(d)} />
            {:else}
              <AxisY formatTick={(d) => ""} />
            {/if}
            <Column showLabels />
          </Svg>
        </LayerCake>
      </div>
      <p class="category-title">{category}</p>
    </div>
  {/each}
</div>

<style>
  .legend-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 0 15px;
    .legend-pair {
      display: flex;
      gap: 7px;
      align-items: center;
    }
    .name {
      font-size: var(--font-size-small);
      line-height: var(--line-height-snug);
    }
    .box {
      height: 12px;
      width: 12px;
    }
  }
  .all-charts {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    margin-left: 35px;
  }
  .chart-container {
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: start;
  }
  .category-container {
    p.category-title {
      margin: 0;
      font-size: var(--font-size-small);
      line-height: var(--line-height-snug);
      text-align: center;
    }
  }
</style>
